import Lightbox from '../../elements/Lightbox';

function initVideoContainer()
{
	const videoContainers = document.querySelectorAll( 'div.video-container, button.on-map.video' );

	if ( !videoContainers.length )
	{
		return;
	}

	Array.from( videoContainers ).forEach( ( it ) => {
		const videoId = it.dataset.videoSrc;

		if ( !videoId )
		{
			return;
		}

		

		function playVideo()
		{
			if ( !it.querySelector( 'iframe' ) )
			{
				it.querySelector( 'div.video-full' ).insertAdjacentHTML( 'beforeend', `<iframe src="https://www.youtube.com/embed/${videoId}?rel=0&amp;showinfo=0&autoplay=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen allowautoplay></iframe>` );
			}
			
			const lightbox = Lightbox.instance;
			const lightboxContent = it.querySelector( 'div.video-full' );
			
			lightbox.open( [ lightboxContent ], () => {
				const iframe = it.querySelector( 'iframe' );

				if ( iframe )
				{
					iframe.remove();
				}
			} );

			document.body.classList.add( 'video-lightbox' );
		}

		it.addEventListener( 'click', playVideo );
	} );
}

export {
	initVideoContainer
};


//////////////////
// WEBPACK FOOTER
// ./app/Common/Video/index.js
// module id = rtac
// module chunks = 12